import {
    RangeControl,
    Button,
} from '@wordpress/components';
import ResBtn from '../res-btn';
import { Fragment, useEffect, useRef } from '@wordpress/element';
import './style.scss';
import { __ } from '@wordpress/i18n';

const ResDimensionControl = ({
    label,
    controlName,
    objAttrs,
    noUnits,
    units,
    min,
    max,
}) => {
    const { attributes, setAttributes } = objAttrs;
    const { resMode } = attributes;
    const controlRef = useRef(null);
    const controlIsLinked = attributes[`${controlName[0]}IsLinked`] !== false;

    const {
        [`${controlName[0]}DeskRange`]: deskTopRange,
        [`${controlName[1]}DeskRange`]: deskRightRange,
        [`${controlName[2]}DeskRange`]: deskBottomRange,
        [`${controlName[3]}DeskRange`]: deskLeftRange,
        [`${controlName[0]}TabRange`]: tabTopRange,
        [`${controlName[1]}TabRange`]: tabRightRange,
        [`${controlName[2]}TabRange`]: tabBottomRange,
        [`${controlName[3]}TabRange`]: tabLeftRange,
        [`${controlName[0]}MobRange`]: mobTopRange,
        [`${controlName[1]}MobRange`]: mobRightRange,
        [`${controlName[2]}MobRange`]: mobBottomRange,
        [`${controlName[3]}MobRange`]: mobLeftRange,
        [`${controlName[0]}Unit`]: topUnit,
    } = attributes;

    if (!units) units = units || ['px', 'em', 'rem', '%'];

    const handleBackspace = (event, side) => {
        event.preventDefault();         
        if (controlIsLinked) {
            let updates = {};            
            if (resMode === 'Desktop') {
                updates = {
                    [`${controlName[0]}DeskRange`]: deskTopRange ? Math.floor(deskTopRange / 10) || undefined : undefined,
                    [`${controlName[1]}DeskRange`]: deskTopRange ? Math.floor(deskTopRange / 10) || undefined : undefined,
                    [`${controlName[2]}DeskRange`]: deskTopRange ? Math.floor(deskTopRange / 10) || undefined : undefined,
                    [`${controlName[3]}DeskRange`]: deskTopRange ? Math.floor(deskTopRange / 10) || undefined : undefined,
                };
            } else if (resMode === 'Tablet') {
                updates = {
                    [`${controlName[0]}TabRange`]: tabTopRange ? Math.floor(tabTopRange / 10) || undefined : undefined,
                    [`${controlName[1]}TabRange`]: tabTopRange ? Math.floor(tabTopRange / 10) || undefined : undefined,
                    [`${controlName[2]}TabRange`]: tabTopRange ? Math.floor(tabTopRange / 10) || undefined : undefined,
                    [`${controlName[3]}TabRange`]: tabTopRange ? Math.floor(tabTopRange / 10) || undefined : undefined,
                };
            } else if (resMode === 'Mobile') {
                updates = {
                    [`${controlName[0]}MobRange`]: mobTopRange ? Math.floor(mobTopRange / 10) || undefined : undefined,
                    [`${controlName[1]}MobRange`]: mobTopRange ? Math.floor(mobTopRange / 10) || undefined : undefined,
                    [`${controlName[2]}MobRange`]: mobTopRange ? Math.floor(mobTopRange / 10) || undefined : undefined,
                    [`${controlName[3]}MobRange`]: mobTopRange ? Math.floor(mobTopRange / 10) || undefined : undefined,
                };
            }
            
            setAttributes(updates);
        } else {
            const  updates = {};
            
            switch (side) {
                case 'top':
                    if (resMode === 'Desktop') {
                        updates[`${controlName[0]}DeskRange`] = deskTopRange ? Math.floor(deskTopRange / 10) || undefined : undefined;
                    } else if (resMode === 'Tablet') {
                        updates[`${controlName[0]}TabRange`] = tabTopRange ? Math.floor(tabTopRange / 10) || undefined : undefined;
                    } else if (resMode === 'Mobile') {
                        updates[`${controlName[0]}MobRange`] = mobTopRange ? Math.floor(mobTopRange / 10) || undefined : undefined;
                    }
                    break;
                case 'right':
                    if (resMode === 'Desktop') {
                        updates[`${controlName[1]}DeskRange`] = deskRightRange ? Math.floor(deskRightRange / 10) || undefined : undefined;
                    } else if (resMode === 'Tablet') {
                        updates[`${controlName[1]}TabRange`] = tabRightRange ? Math.floor(tabRightRange / 10) || undefined : undefined;
                    } else if (resMode === 'Mobile') {
                        updates[`${controlName[1]}MobRange`] = mobRightRange ? Math.floor(mobRightRange / 10) || undefined : undefined;
                    }
                    break;
                case 'bottom':
                    if (resMode === 'Desktop') {
                        updates[`${controlName[2]}DeskRange`] = deskBottomRange ? Math.floor(deskBottomRange / 10) || undefined : undefined;
                    } else if (resMode === 'Tablet') {
                        updates[`${controlName[2]}TabRange`] = tabBottomRange ? Math.floor(tabBottomRange / 10) || undefined : undefined;
                    } else if (resMode === 'Mobile') {
                        updates[`${controlName[2]}MobRange`] = mobBottomRange ? Math.floor(mobBottomRange / 10) || undefined : undefined;
                    }
                    break;
                case 'left':
                    if (resMode === 'Desktop') {
                        updates[`${controlName[3]}DeskRange`] = deskLeftRange ? Math.floor(deskLeftRange / 10) || undefined : undefined;
                    } else if (resMode === 'Tablet') {
                        updates[`${controlName[3]}TabRange`] = tabLeftRange ? Math.floor(tabLeftRange / 10) || undefined : undefined;
                    } else if (resMode === 'Mobile') {
                        updates[`${controlName[3]}MobRange`] = mobLeftRange ? Math.floor(mobLeftRange / 10) || undefined : undefined;
                    }
                    break;
                default:
                    break;
            }
            
            setAttributes(updates);
        }
    };
    
    useEffect(() => {
        const currentControlRef = controlRef.current;
        
        const handleKeyDown = (event) => {
            // Only process if the event happened inside this component
            if (!currentControlRef.contains(event.target)) {
                return;
            }
            
            if (event.key === 'Backspace') {
                let side;
                switch (event.target.getAttribute('aria-label')) {
                    case __('Top', 'gutenium'):
                        side = 'top';
                        break;
                    case __('Right', 'gutenium'):
                        side = 'right';
                        break;
                    case __('Bottom', 'gutenium'):
                        side = 'bottom';
                        break;
                    case __('Left', 'gutenium'):
                        side = 'left';
                        break;
                    default:
                        side = null;
                        break;
                }
                if (side) {
                    handleBackspace(event, side);
                }
            }
        };
    
        // Add the event listener to this specific component's DOM element
        if (currentControlRef) {
            currentControlRef.addEventListener('keydown', handleKeyDown);
        }
        
        return () => {
            // Clean up event listener when component unmounts
            if (currentControlRef) {
                currentControlRef.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [controlIsLinked, resMode, deskTopRange, deskRightRange, deskBottomRange, deskLeftRange, 
        tabTopRange, tabRightRange, tabBottomRange, tabLeftRange, 
        mobTopRange, mobRightRange, mobBottomRange, mobLeftRange]);

    return (
        <div className="gutnm-dimension-control-wrap" ref={controlRef}>
            <p className="gutnm-dimension-label">{label}</p>
            <div className="gutnm-res-rangle-control">
                <ResBtn resMode={resMode} setAttributes={setAttributes} />
                <div className="gutnm-unit">
                    {!noUnits && (
                        <div className="units-wrapper">
                            {units &&
                                units.map((u, index) => {
                                    return (
                                        <Button
                                            className="unit-btn"
                                            variant={
                                                topUnit === u
                                                    ? 'primary'
                                                    : 'secondary'
                                            }
                                            key={index}
                                            onClick={() =>
                                                setAttributes({
                                                    [`${controlName[0]}Unit`]: u,
                                                    [`${controlName[1]}Unit`]: u,
                                                    [`${controlName[2]}Unit`]: u,
                                                    [`${controlName[3]}Unit`]: u,
                                                })
                                            }
                                        >
                                            {u}
                                        </Button>
                                    );
                                })}
                        </div>
                    )}
                </div>
            </div>
            <div className="gutnm-dimension-control">
                <div className="gutnm-res-controls">
                    {resMode === 'Desktop' && (
                        <div className="gutnm-single-rangle">
                            {controlIsLinked ? (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={deskTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}DeskRange`]: value,
                                                [`${controlName[1]}DeskRange`]: value,
                                                [`${controlName[2]}DeskRange`]: value,
                                                [`${controlName[3]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={deskRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}DeskRange`]: value,
                                                [`${controlName[1]}DeskRange`]: value,
                                                [`${controlName[2]}DeskRange`]: value,
                                                [`${controlName[3]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={deskBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}DeskRange`]: value,
                                                [`${controlName[1]}DeskRange`]: value,
                                                [`${controlName[2]}DeskRange`]: value,
                                                [`${controlName[3]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={deskLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}DeskRange`]: value,
                                                [`${controlName[1]}DeskRange`]: value,
                                                [`${controlName[2]}DeskRange`]: value,
                                                [`${controlName[3]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={deskTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={deskRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[1]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={deskBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[2]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={deskLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[3]}DeskRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            )}
                        </div>
                    )}
                    {resMode === 'Tablet' && (
                        <div className="gutnm-single-rangle">
                            {controlIsLinked ? (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={tabTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}TabRange`]: value,
                                                [`${controlName[1]}TabRange`]: value,
                                                [`${controlName[2]}TabRange`]: value,
                                                [`${controlName[3]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={tabRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}TabRange`]: value,
                                                [`${controlName[1]}TabRange`]: value,
                                                [`${controlName[2]}TabRange`]: value,
                                                [`${controlName[3]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={tabBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}TabRange`]: value,
                                                [`${controlName[1]}TabRange`]: value,
                                                [`${controlName[2]}TabRange`]: value,
                                                [`${controlName[3]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={tabLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}TabRange`]: value,
                                                [`${controlName[1]}TabRange`]: value,
                                                [`${controlName[2]}TabRange`]: value,
                                                [`${controlName[3]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={tabTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={tabRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[1]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={tabBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[2]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={tabLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[3]}TabRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            )}
                        </div>
                    )}
                    {resMode === 'Mobile' && (
                        <div className="gutnm-single-rangle">
                            {controlIsLinked ? (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={mobTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}MobRange`]: value,
                                                [`${controlName[1]}MobRange`]: value,
                                                [`${controlName[2]}MobRange`]: value,
                                                [`${controlName[3]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={mobRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}MobRange`]: value,
                                                [`${controlName[1]}MobRange`]: value,
                                                [`${controlName[2]}MobRange`]: value,
                                                [`${controlName[3]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={mobBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}MobRange`]: value,
                                                [`${controlName[1]}MobRange`]: value,
                                                [`${controlName[2]}MobRange`]: value,
                                                [`${controlName[3]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={mobLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}MobRange`]: value,
                                                [`${controlName[1]}MobRange`]: value,
                                                [`${controlName[2]}MobRange`]: value,
                                                [`${controlName[3]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <RangeControl
                                        label={__('Top', 'gutenium')}
                                        value={mobTopRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[0]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Right', 'gutenium')}
                                        value={mobRightRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[1]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Bottom', 'gutenium')}
                                        value={mobBottomRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[2]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                    <RangeControl
                                        label={__('Left', 'gutenium')}
                                        value={mobLeftRange}
                                        onChange={(value) =>
                                            setAttributes({
                                                [`${controlName[3]}MobRange`]: value,
                                            })
                                        }
                                        min={min}
                                        max={max}
                                    />
                                </Fragment>
                            )}
                        </div>
                    )}
                </div>
                <div className="gutnm-dimension-link">
                    <Button
                        className="unit-btn"
                        icon={controlIsLinked ? 'admin-links' : 'editor-unlink'}
                        label={
                            controlIsLinked
                                ? __('Link values', 'gutenium')
                                : __('Unlink values', 'gutenium')
                        }
                        onClick={() =>
                            setAttributes({ [`${controlName[0]}IsLinked`]: !controlIsLinked })
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default ResDimensionControl;